import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5be85827"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "content" };
const _hoisted_2 = { class: "main_title" };
const _hoisted_3 = { class: "sub_title" };
const _hoisted_4 = { class: "main_box" };
const _hoisted_5 = { class: "flex contents" };
const _hoisted_6 = { class: "titles" };
const _hoisted_7 = { class: "value" };
const _hoisted_8 = { class: "flex contents" };
const _hoisted_9 = { class: "titles" };
const _hoisted_10 = { class: "value" };
const _hoisted_11 = { class: "flex contents" };
const _hoisted_12 = { class: "titles" };
const _hoisted_13 = { class: "value" };
const _hoisted_14 = { class: "flex contents" };
const _hoisted_15 = { class: "titles" };
const _hoisted_16 = { class: "value" };
const _hoisted_17 = { class: "flex contents" };
const _hoisted_18 = { class: "titles" };
const _hoisted_19 = { class: "value" };
const _hoisted_20 = { class: "flex contents" };
const _hoisted_21 = { class: "titles" };
const _hoisted_22 = { class: "value" };
const _hoisted_23 = { class: "flex buttons" };
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import CheckBox from '@/materials/atoms/CheckBox.vue';
import { ref } from 'vue';
import { decimalize, setTimezone } from '@/logics/utils';
import { useStore } from '@/store/store';
import { useMessage } from '@/const/messages';
import { useSound } from '@/logics/sound';
export default /*#__PURE__*/ _defineComponent({
    props: {
        order: null,
        base: null,
        quote: null
    },
    emits: ["canceling", "close"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const { format, CANCEL_CONFIRM_TITLES } = useMessage();
        const { closeClear, play } = useSound();
        const onCancel = (id) => {
            emit('canceling', id, check.value);
            emit('close');
        };
        const onClose = () => {
            play(closeClear);
            emit('close');
        };
        const check = ref(false);
        const onChangeCheck = (isChecked) => {
            check.value = isChecked;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "overlay overlay_z",
                    onClick: onClose
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("label", null, _toDisplayString(_unref(format)(_unref(CANCEL_CONFIRM_TITLES).TITLE)), 1),
                        _createVNode(MaterialIcon, {
                            name: "close",
                            class: "close_button",
                            onClick: onClose
                        })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(CheckBox, {
                            mode: "dark",
                            label: _unref(format)(_unref(CANCEL_CONFIRM_TITLES).LEAVE_OUT_CHECK),
                            id: "cancel",
                            isInitCheck: false,
                            onChange: onChangeCheck
                        }, null, 8, ["label"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(format)(_unref(CANCEL_CONFIRM_TITLES).ORDER_ID)), 1),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("label", null, _toDisplayString(props.order.id), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(format)(_unref(CANCEL_CONFIRM_TITLES).PAIR)), 1),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("label", null, _toDisplayString(props.base) + " / " + _toDisplayString(props.quote), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(format)(_unref(CANCEL_CONFIRM_TITLES).ORDER)), 1),
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("label", null, _toDisplayString(props.order.side), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(format)(_unref(CANCEL_CONFIRM_TITLES).EXCUTED_STATUS)), 1),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("label", null, _toDisplayString(props.order.actions), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(format)(_unref(CANCEL_CONFIRM_TITLES).EXCUTED_AND_AMOUNT)), 1),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("label", null, _toDisplayString(_unref(decimalize)(props.order.executed, props.base, _unref(store).state.currencyInfo)) + " / " + _toDisplayString(props.order.amount !== null ? _unref(decimalize)(props.order.amount, props.base, _unref(store).state.currencyInfo) : '---'), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(format)(_unref(CANCEL_CONFIRM_TITLES).ORDER_TIME)), 1),
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("label", null, _toDisplayString(_unref(setTimezone)(String(_unref(store).state.userSettings.localTime), props.order.time, 'YYYY-MM-DD HH:mm:ss')), 1)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", {
                            onClick: onClose,
                            class: "cancel"
                        }, _toDisplayString(_unref(format)(_unref(CANCEL_CONFIRM_TITLES).CLOSE)), 1),
                        _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (onCancel(props.order.id))),
                            class: "order"
                        }, _toDisplayString(_unref(format)(_unref(CANCEL_CONFIRM_TITLES).CANCEL)), 1)
                    ])
                ])
            ], 64));
        };
    }
});
